// Central content definitions for ZasyaOnline.
// All public copy, product data, navigation and customer references live here so
// an administrator can update content without touching layout code.
// Images are curated stand-ins — see docs/ASSETS.md for the replacement inventory.

export const IMAGES = {
  heroFleet:
    "https://images.unsplash.com/photo-1695222833131-54ee679ae8e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxmbGVldCUyMG1hbmFnZW1lbnQlMjB0cmFuc3BvcnQlMjBsb2dpc3RpY3MlMjBkYXNoYm9hcmQlMjB0cnVja3xlbnwwfHx8fDE3OTI5MDgzMTF8MA&ixlib=rb-4.1.0&q=85",
  fleetTrucks:
    "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxmbGVldCUyMG1hbmFnZW1lbnQlMjB0cmFuc3BvcnQlMjBsb2dpc3RpY3MlMjBkYXNoYm9hcmQlMjB0cnVja3xlbnwwfHx8fDE3OTI5MDgzMTF8MA&ixlib=rb-4.1.0&q=85",
  callCenter:
    "https://images.unsplash.com/photo-1626863905121-3b0c0ed7b94c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjYWxsJTIwY2VudGVyJTIwYWklMjBjdXN0b21lciUyMHNlcnZpY2UlMjBoZWFkc2V0JTIwb3BlcmF0b3J8ZW58MHx8fHwxNzkyOTA4MzExfDA&ixlib=rb-4.1.0&q=85",
  callOperator:
    "https://images.unsplash.com/photo-1712159018726-4564d92f3ec2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxjYWxsJTIwY2VudGVyJTIwYWklMjBjdXN0b21lciUyMHNlcnZpY2UlMjBoZWFkc2V0JTIwb3BlcmF0b3J8ZW58MHx8fHwxNzkyOTA4MzExfDA&ixlib=rb-4.1.0&q=85",
  crane:
    "https://images.pexels.com/photos/29502217/pexels-photo-29502217.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  craneSky:
    "https://images.pexels.com/photos/9150899/pexels-photo-9150899.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  teamMeeting:
    "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzNzl8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjB0ZWFtJTIwdGVjaG5vbG9neSUyMGNvbGxhYm9yYXRpb24lMjBtZWV0aW5nfGVufDB8fHx8MTc5MjkwODMxNnww&ixlib=rb-4.1.0&q=85",
  teamWhiteboard:
    "https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzNzl8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjB0ZWFtJTIwdGVjaG5vbG9neSUyMGNvbGxhYm9yYXRpb24lMjBtZWV0aW5nfGVufDB8fHx8MTc5MjkwODMxNnww&ixlib=rb-4.1.0&q=85",
  learning:
    "https://images.pexels.com/photos/9301156/pexels-photo-9301156.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  learningTablet:
    "https://images.pexels.com/photos/4443160/pexels-photo-4443160.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV_LINKS = [
  { label: "Home", path: "/", testId: "nav-home-link" },
  { label: "Products", path: "/products", testId: "nav-products-link" },
  { label: "Consulting & Solutions", path: "/consulting", testId: "nav-consulting-link" },
  { label: "Customers", path: "/customers", testId: "nav-customers-link" },
  { label: "Insights", path: "/insights", testId: "nav-insights-link" },
  { label: "About Us", path: "/about", testId: "nav-about-link" },
];

export const FLEET_SIZE_OPTIONS = [
  "1–10",
  "11–25",
  "26–50",
  "51–100",
  "101–250",
  "251–500",
  "Over 500",
];

export const PRODUCTS = [
  {
    id: "moveos",
    name: "MoveOS",
    path: "/products/moveos",
    url: "https://moveos.in/",
    category: "Transport & Fleet Management",
    headline: "Run your entire fleet from one system.",
    shortDescription:
      "Vehicle, driver, trip and maintenance operations for transport businesses — from quotation to trip completion.",
    description:
      "MoveOS brings day-to-day transport and fleet operations into a single system. Manage vehicles, drivers and clients, raise quotations and work orders, run trip operations, and keep an eye on fuel, maintenance and compliance information — with operational dashboards and GPS-based fleet visibility throughout.",
    image: IMAGES.heroFleet,
    imageAlt: "Fleet of trucks on a highway, representing MoveOS transport operations",
    logo: "/assets/products/moveos-logo.png",
    screenshots: [
      { src: "/assets/products/moveos-screen-dashboard.png", label: "Executive Dashboard", alt: "MoveOS executive dashboard with command center KPIs and operational insights" },
      { src: "/assets/products/moveos-screen-trips.png", label: "Trip Operations", alt: "MoveOS trip operations board with active, scheduled and completed trips" },
      { src: "/assets/products/moveos-screen-gps.png", label: "GPS & Telematics", alt: "MoveOS live GPS map showing fleet positions across the region" },
      { src: "/assets/products/moveos-screen-compliance.png", label: "Compliance", alt: "MoveOS compliance summary with fleet health and vehicle document status" },
      { src: "/assets/products/moveos-screen-fleet.png", label: "Fleet & Asset Master", alt: "MoveOS fleet and asset master with vehicle and trailer records" },
    ],
    capabilityGroups: [
      {
        title: "Fleet Operations",
        items: [
          "Vehicle, driver and client management",
          "Quotations and work orders",
          "Trip operations",
        ],
      },
      {
        title: "Visibility & Reporting",
        items: [
          "Operational dashboards and reports",
          "GPS and fleet visibility",
          "Vehicle and driver compliance information",
        ],
      },
      {
        title: "Cost & Upkeep",
        items: ["Fuel management", "Maintenance management"],
      },
    ],
    audiences: [
      "Transport and logistics operators",
      "Fleet owners and aggregators",
      "Businesses running dedicated vehicle fleets",
    ],
    lifecycle: ["Quote", "Work Order", "Trip", "Track", "Maintain"],
    demoFieldsNote:
      "The MoveOS demo request asks for your fleet size and primary requirement so the team can prepare a relevant walkthrough.",
    seo: {
      title: "MoveOS — Transport & Fleet Management | ZasyaOnline",
      description:
        "MoveOS is ZasyaOnline's transport and fleet management product: vehicles, drivers, trips, fuel, maintenance, GPS visibility and operational reporting.",
    },
  },
  {
    id: "mybantu",
    name: "myBantu",
    path: "/products/mybantu",
    url: "https://www.mybantu.in/",
    category: "AI-Powered Call Centre",
    headline: "Your Instant Call Centre. Set Up. Choose. Go.",
    shortDescription:
      "An AI-powered call centre for businesses — configurable caller experiences, industry workflows and appointment booking.",
    description:
      "myBantu gives a business its own AI-powered call centre without the overhead of building one. Set it up, choose your caller experience and language options, and go live with industry-specific call workflows that book appointments, capture enquiries and callbacks, and surface business activity — with mobile app access to supported bookings and customer information.",
    image: IMAGES.callCenter,
    imageAlt: "Call-centre professional wearing a headset, representing myBantu",
    logo: "/assets/products/mybantu-logo.png",
    screenshots: [
      { src: "/assets/products/mybantu-app-home.png", label: "Mobile App — Home", alt: "myBantu mobile app home screen with booking activity and upcoming bookings", fit: "contain" },
      { src: "/assets/products/mybantu-app-voicebot.png", label: "Caller Experience Setup", alt: "myBantu guided setup for caller experience, interaction mode and language options", fit: "contain" },
    ],
    capabilityGroups: [
      {
        title: "Setup & Experience",
        items: [
          "Call-centre setup and activation",
          "Configurable caller experiences",
          "Supported language options",
        ],
      },
      {
        title: "Industry Workflows",
        items: [
          "Industry-specific call workflows",
          "Appointment booking for supported workflows",
          "Enquiry and callback capture",
        ],
      },
      {
        title: "On the Go",
        items: [
          "Mobile app access to supported bookings and customer information",
          "Business activity views",
        ],
      },
    ],
    scenarios: [
      {
        name: "Salon",
        detail:
          "Callers book appointments through the myBantu call flow; the salon sees bookings and activity in the app.",
      },
      {
        name: "Clinic",
        detail:
          "Patients reach the clinic's call centre, book appointments and leave enquiries for callback.",
      },
      {
        name: "Cleaning Business",
        detail:
          "New service enquiries are captured with details and routed for callback and scheduling.",
      },
    ],
    audiences: [
      "Salons and wellness businesses",
      "Clinics and healthcare practices",
      "Cleaning and home-services businesses",
    ],
    lifecycle: ["Set Up", "Choose", "Go", "Book", "Track"],
    note: "Plans and pricing are published on the myBantu website, where you can also explore the product in detail.",
    seo: {
      title: "myBantu — AI-Powered Call Centre | ZasyaOnline",
      description:
        "myBantu is ZasyaOnline's AI-powered call centre for businesses: configurable caller experiences, industry workflows, appointment booking and enquiry capture.",
    },
  },
  {
    id: "learnsphere",
    name: "LearnSphere",
    path: "/products/learnsphere",
    // Proposed production URL — pending confirmation before launch (see docs/HANDOVER.md).
    url: "https://learnsphere.zasya.online/",
    category: "Enterprise Learning & Compliance Platform",
    headline: "Learning that proves itself.",
    shortDescription:
      "Courses, assessments, certification and learner reporting for enterprises that need learning to hold up under scrutiny.",
    description:
      "LearnSphere is an enterprise learning and compliance platform covering the full learning lifecycle: create courses, deliver them to assigned learners, assess and evaluate, certify, and track progress with reporting — backed by enterprise administration with users, roles and permissions.",
    image: IMAGES.learning,
    imageAlt: "Instructor-led enterprise training session, representing LearnSphere",
    logo: "/assets/products/learnsphere-logo.png",
    screenshots: [
      { src: "/assets/products/learnsphere-screen-dashboard.png", label: "Admin Dashboard", alt: "LearnSphere admin dashboard with user, course, enrollment and certificate metrics" },
      { src: "/assets/products/learnsphere-screen-courses.png", label: "Course Management", alt: "LearnSphere course management with trainer, category, status, version and enrollment columns" },
      { src: "/assets/products/learnsphere-screen-assessments.png", label: "Assessments", alt: "LearnSphere assessment builder with questions, passing score, attempts and status settings" },
      { src: "/assets/products/learnsphere-screen-certificates.png", label: "Certificates", alt: "LearnSphere certificates register with issued dates and grades" },
    ],
    capabilityGroups: [
      {
        title: "Learning Delivery",
        items: [
          "Course management",
          "Learning delivery and learner assignments",
          "Certification",
        ],
      },
      {
        title: "Assessment & Evidence",
        items: [
          "Assessments and evaluation workflows",
          "Learner progress and reporting",
        ],
      },
      {
        title: "Enterprise Control",
        items: ["Enterprise administration", "Users, roles and permissions"],
      },
    ],
    audiences: [
      "EdTech and professional training organisations",
      "Pharma and life sciences companies",
      "Manufacturing and industrial organisations",
    ],
    lifecycle: ["Create", "Deliver", "Assess", "Certify", "Track"],
    note: "Detailed product marketing and the product-specific demo journey live on the dedicated LearnSphere website.",
    seo: {
      title: "LearnSphere — Enterprise Learning & Compliance | ZasyaOnline",
      description:
        "LearnSphere is ZasyaOnline's enterprise learning and compliance platform: courses, assessments, certification, learner reporting and enterprise administration.",
    },
  },
  {
    id: "cranesoftwares",
    name: "CraneSoftwares",
    path: "/products/cranesoftwares",
    url: "https://cranesoftwares.com/",
    category: "Crane Rental & Heavy Equipment Operations",
    headline: "One platform. Connected operations.",
    shortDescription:
      "Quotations, work orders, billing, HR and compliance-data workflows for crane rental and heavy equipment businesses.",
    description:
      "CraneSoftwares connects the operational chain of a crane rental or heavy equipment business: quotations and work orders, task management, billing and invoicing with accounts-receivable workflows, HR workflows, inventory, role-specific dashboards, and reports — including access to supported vehicle and driver compliance data.",
    image: IMAGES.crane,
    imageAlt: "Heavy crane at a construction site, representing CraneSoftwares",
    logo: "/assets/products/cranesoftwares-logo.png",
    screenshots: [
      { src: "/assets/products/cranesoftwares-screen-ops.png", label: "Operations Dashboard", alt: "CraneSoftwares operations dashboard with live work order, task, customer, invoice and asset counts" },
      { src: "/assets/products/cranesoftwares-screen-reports.png", label: "Executive Reports", alt: "CraneSoftwares executive approval audit report with document status tracking" },
      { src: "/assets/products/cranesoftwares-screen-team.png", label: "Team & HR", alt: "CraneSoftwares team structure view with export option" },
    ],
    capabilityGroups: [
      {
        title: "Commercial Operations",
        items: [
          "Quotations",
          "Work orders",
          "Billing and invoicing, including accounts-receivable workflows",
        ],
      },
      {
        title: "People & Assets",
        items: ["Task management", "HR workflows", "Inventory management"],
      },
      {
        title: "Insight & Compliance Data",
        items: [
          "Role-specific dashboards",
          "Reports and analytics",
          "Vehicle and driver compliance validation with supported VAHAN, SARATHI and e-Challan information",
        ],
      },
    ],
    complianceNote:
      "CraneSoftwares provides access to supported external compliance data sources such as VAHAN, SARATHI and e-Challan. It surfaces information to support your checks; it does not itself certify or guarantee legal or regulatory compliance.",
    audiences: [
      "Crane rental companies",
      "Heavy equipment hire businesses",
      "Infrastructure and construction fleets",
    ],
    lifecycle: ["Quote", "Work Order", "Execute", "Invoice", "Collect"],
    seo: {
      title: "CraneSoftwares — Crane Rental Operations Platform | ZasyaOnline",
      description:
        "CraneSoftwares is ZasyaOnline's crane rental and heavy equipment operations platform: quotations, work orders, billing, HR, inventory and compliance-data workflows.",
    },
  },
];

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);

export const SERVICES = [
  {
    id: "custom-software",
    title: "Custom Software & Application Development",
    need: "When off-the-shelf software doesn't fit the way your business actually runs.",
    detail:
      "We design and build business applications shaped around your workflows — the same engineering practice behind our own products, applied to your requirements.",
  },
  {
    id: "integration-architecture",
    title: "Enterprise Integration & Solution Architecture",
    need: "When systems don't talk to each other and manual work fills the gaps.",
    detail:
      "We architect and implement integrations between your applications, data and operational systems, and design solutions that hold up as you scale.",
  },
  {
    id: "infrastructure-managed",
    title: "Infrastructure & Managed Services",
    need: "When technology needs to run reliably without consuming your team's attention.",
    detail:
      "We take responsibility for running and maintaining infrastructure and managed technology services so your team can focus on the business.",
  },
  {
    id: "contact-centre",
    title: "Contact-Centre Consulting & Implementation",
    need: "When customer conversations need structure, tooling and integration.",
    detail:
      "Consulting, solution architecture, platform implementation, telephony integration and custom development for contact-centre environments.",
  },
  {
    id: "ai-solutions",
    title: "AI-Powered Business Solutions & Automation",
    need: "When repetitive decisions and communication slow the business down.",
    detail:
      "We apply AI where it is genuinely useful — automating business communication and workflows, as we do in our own product myBantu.",
  },
  {
    id: "platforms-consulting",
    title: "Enterprise Platforms & Technology Consulting",
    need: "When technology decisions need an experienced, vendor-neutral view.",
    detail:
      "Advisory and consulting across enterprise platforms and technology direction, grounded in hands-on delivery experience.",
  },
];

export const CUSTOMERS = [
  {
    name: "Sanghvi Movers",
    engagement: "Customised Software",
    description:
      "Customised software developed for one of India's leading heavy-lift and crane rental companies.",
  },
  {
    name: "Pune Logitech",
    engagement: "Customised Software",
    description: "Customised software supporting transport and logistics operations.",
  },
  {
    name: "Indian Railways",
    engagement: "Customised Software",
    description: "Customised software engagement for Indian Railways.",
  },
  {
    name: "Sudhir Cranes",
    engagement: "MoveOS",
    description: "Transport and fleet operations run on MoveOS.",
  },
  {
    name: "Raja Transport",
    engagement: "MoveOS",
    description: "Transport and fleet operations run on MoveOS.",
  },
  {
    name: "Procell Biologics",
    engagement: "Infrastructure Services",
    description: "Infrastructure and managed technology services.",
    flag: "Customer name spelling to be verified before publication.",
  },
  {
    name: "Tashi Cell",
    engagement: "Contact-Centre Consulting & Implementation",
    description:
      "Consulting, solution architecture, platform implementation, telephony integration and custom development for contact-centre operations.",
  },
  {
    name: "Bank of Bhutan",
    engagement: "Contact-Centre Consulting & Implementation",
    description:
      "Consulting, solution architecture, platform implementation, telephony integration and custom development for contact-centre operations.",
  },
];

export const APPROACH_STEPS = [
  {
    step: "01",
    title: "Discovery",
    detail:
      "We start by understanding how the business actually operates — the workflows, constraints and goals — before proposing any technology.",
  },
  {
    step: "02",
    title: "Design",
    detail:
      "We shape the solution: architecture, product fit, integrations and a delivery plan that the business can review before build begins.",
  },
  {
    step: "03",
    title: "Delivery",
    detail:
      "We implement in working stages, with regular checkpoints, so what lands is what was agreed — and it works in your environment.",
  },
  {
    step: "04",
    title: "Improvement",
    detail:
      "After go-live we stay involved: operating, refining and extending the solution as the business evolves.",
  },
];

export const INSIGHT_CATEGORIES = [
  "Transport & Fleet Operations",
  "AI-Powered Business Communication",
  "Enterprise Learning",
  "Contact-Centre Consulting",
  "Crane & Heavy Equipment",
];

export const OFFICES = [
  {
    label: "Registered Office",
    lines: ["Flat 10D, Tower A7, No. 328, Olympia Grande,", "Pallavaram, Chennai, Tamil Nadu 600043"],
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Olympia+Grande+Apartments,+Pallavaram,+Chennai,+Tamil+Nadu+600043",
  },
  {
    label: "Branch Office",
    lines: ["Tower 6, 405, Raheja Vistas Premier,", "Mohammedwadi, Pune, Maharashtra 411060"],
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Raheja+Vistas+Premier,+Mohammedwadi,+Pune,+Maharashtra+411060",
  },
];

export const SITE = {
  name: "ZasyaOnline",
  legalName: "ZasyaOnline Pvt Ltd",
  baseUrl: "https://www.zasyaonline.com",
  defaultTitle: "ZasyaOnline — Software Products & Enterprise Technology",
  defaultDescription:
    "ZasyaOnline Pvt Ltd builds software products — MoveOS, myBantu, LearnSphere and CraneSoftwares — and delivers enterprise consulting, integration and managed technology services.",
};
